import react, { useEffect, useRef, useState } from "react";
import "../styles/Components/PrescriptionTemplate.scss";
import { postAppointment, postPrescriptionTemplate } from "../Redux/Thunk/Actions";
import { prescriptionType, patientid } from "../Redux/Slice/rootSlice";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../assets/images/ascas.svg";
import Headers from "./Header/Headers";
function PrescriptionTemplate_temp(props) {
  const selectedTab = useSelector((state) => state.counter.prescriptionType);
  const patientId = useSelector((state) => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
    });

  const [show, setshow] = useState(false);
  const Content = useRef();
  const [valueChange, setvalueChange] = useState({
    dualMarker: "Given",
    row1: "1-0-0",
    row2: "1-0-0",
    row3: "1-0-0",
    row6: "1-0-0",
    drop1: "T.TRITOFER XT",
    drop2: "T.INTAFOL D",
    drop3: "T.CALOZEM PLUS",
    drop4: "MAXVIDA",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // visit: "",
  //   lmp: "",
  //   edd: "",
  //   pog: "",
  //   ntScan: "",
  //   db: "",
  //   dualMarker: "Given",
  //   complaints: "",
  //   oe: "",
  //   pedal: "",
  //   pr: "",
  //   BP: "",
  //   Wt: "",
  //   ppw: "",
  //   date: "",
  //   hb: "",
  //   pvc: "",
  //   db: "",
  //   db: "",
  //   db: "",
  //   db: "",

  const handleChange = (e) => {
    setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
    if (e.target.name === "nextappointment") {
      const dateTime = e.target.value.split("T");
      setAppointmentData({
      ...appointmentData,
      date: dateTime[0],
      time: dateTime[1],
      p_uhid: props.patientsData.p_uhid,
      name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
      status: "Not Visited",
      notes: "Booking Visit",
      patient_id: patientId,
      });
      }
  };


  // console.log(valueChange, "value");
  const handletest = () => {
    props.loaderchange("true");

    setshow(true);
    setTimeout(() => {
      const CreateThunk = async () => {
        let htmlPayload;
        htmlPayload = document.getElementById(
          "prescriptionReportWrap"
        ).innerHTML;
        // console.log(htmlPayload, "liki");

        const payload = {
          payload: {
            patient_id: patientId,
            template_type: selectedTab,
            prescription_template: htmlPayload,
          },
        };

        const createNewAppointment = async () => {
          console.log(appointmentData);
          await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment();
        props.loaderchange(true);
        const patentDetails = postPrescriptionTemplate(payload);
        const response = await dispatch(patentDetails);
        if (response?.payload?.status?.code === 200) {
          props.loaderchange(false);
          navigate("/PatientView");
          Swal.fire({
            title: "Successful.",
            text: "Record added successful.",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          props.loaderchange("false");

        } else {
          props.loaderchange("false");
          props.popupalert("true");
          props.popuptext("Network went wrong, Please try after some time.");
          // props.popuptext(response?.status?.message);
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
        }
      };
      CreateThunk();
    }, 2000);
  };

  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };
  return (
    <>
      <div
        className=""
        ref={Content}
        style={{ padding: "40px" }}
        id="trimester"
      >
        <div style={{ width: "100%" }}>
          <img
            className="header_image"
            // src={"https://s3.amazonaws.com/likodi.com/ascslogo.png"}
            src={headerimage}
            style={{
              // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

              width: "100%",
              margin: "0 auto",
            }}
          ></img>
        </div>
        <div
          style={{
            // display: "flex",
            alignItems: "center",
            justifyContent: "cen",
          }}
        >
          {/* <h1 style={{    marginBottom: '35px',fontWeight: 600}}>FIRST TRIMESTER</h1> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={valueChange.gender1}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>

          <h3 style={{}}>VISIT REMARKS:</h3>
          <textarea
            className={`createTime ${show ? "hide" : "show"}`}
            onChange={(e) => handleChange(e)}
            name="visit"
            style={{
              width: "600px",
              height: "100px",
              border: "1px solid #ddd",
              outline: "none",
              padding: "10px",
            }}
          ></textarea>
          <span
            className={`Textarea ${!show ? "hide" : "show"}`}
            style={{ width: "550px", height: "auto", wordWrap: "break-word" }}
          >
            &nbsp;{valueChange.visit}
          </span>
        </div>
        <div style={{ marginTop: "20px" }}>
          <span style={{ fontWeight: "600" }}>LMP:</span>
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            onChange={(e) => handleChange(e)}
            name="lmp"
            style={{
              border: "1px solid #ddd",
              width: "180px",
              marginLeft: "10px",
              padding: "10px",
              outline: "none",
            }}
          ></input>
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{valueChange.lmp}
          </span>

          <span style={{ fontWeight: "600", marginLeft: "10px" }}>EDD:</span>
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            onChange={(e) => handleChange(e)}
            name="edd"
            style={{
              border: "1px solid #ddd",
              width: "180px",
              marginLeft: "10px",
              padding: "10px",
              outline: "none",
            }}
          ></input>
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{valueChange.edd}
          </span>
          <span style={{ fontWeight: "600", marginLeft: "10px" }}>POG:</span>
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            onChange={(e) => handleChange(e)}
            name="pog"
            style={{
              border: "1px solid #ddd",
              width: "180px",
              marginLeft: "10px",
              padding: "10px",
              outline: "none",
            }}
            // // placeholder="POG.."
          ></input>
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{valueChange.pog}
          </span>
        </div>
        <div style={{ marginTop: "20px" }}>
          <span style={{ fontWeight: "600" }}>NT SCAN:</span>
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            onChange={(e) => handleChange(e)}
            name="ntScan"
            style={{
              border: "1px solid #ddd",
              width: "180px",
              marginLeft: "10px",
              padding: "10px",
              outline: "none",
            }}
            // // placeholder="NT SCAN.."
          ></input>
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{valueChange.ntScan}
          </span>

          <span style={{ fontWeight: "600", marginLeft: "10px" }}>D/B:</span>
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            onChange={(e) => handleChange(e)}
            name="db"
            style={{
              border: "1px solid #ddd",
              width: "180px",
              marginLeft: "10px",
              padding: "10px",
              outline: "none",
            }}
            // // placeholder="D/B.."
          ></input>
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{valueChange.db}
          </span>

          <span style={{ fontWeight: "600", marginLeft: "10px" }}>
            DUAL MARKER:
          </span>
          <select
            className={`createTime ${show ? "hide" : "show"}`}
            onChange={(e) => handleChange(e)}
            name="dualMarker"
            style={{
              border: "1px solid #ddd",
              width: "180px",
              marginLeft: "10px",
              padding: "10px",
              outline: "none",
              backgroundColor: "#fff",
            }}
            // // placeholder="POG.."
          >
            <option selected disabled>
              Select
            </option>
            <option value={"Given"}>Given</option>
            <option value={"Not Given"}>Not Given</option>
          </select>
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{valueChange.dualMarker}
          </span>
        </div>
        <div
          style={{
            marginTop: "20px",
            marginTop: "30px",
            isplay: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              //   flexDirection: "column",
            }}
          >
            <h3>COMPLAINTS:</h3>
            <textarea
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChange(e)}
              name="complaints"
              style={{
                width: "600px",
                height: "100px",
                border: "1px solid #ddd",
                outline: "none",
                padding: "10px",
              }}
            ></textarea>
            <span
              className={`Textarea ${!show ? "hide" : "show"}`}
              style={{ width: "550px", height: "auto", wordWrap: "break-word" }}
            >
              &nbsp;{valueChange.complaints}
            </span>
            {/* <span
              style={{
                width: "550px",
                height: "auto",
                wordWrap: "break-word",
                marginLeft: "50px",
              }}
            >
              &nbsp;{valueChange.complaints}
            </span> */}
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <span style={{ fontWeight: "600" }}>O/E:</span>
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            onChange={(e) => handleChange(e)}
            name="oe"
            style={{
              border: "1px solid #ddd",
              width: "180px",
              marginLeft: "10px",
              padding: "10px",
              outline: "none",
            }}
            // // placeholder="O/E.."
          ></input>
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{valueChange.oe}
          </span>
          <span style={{ fontWeight: "600", marginLeft: "10px" }}>
            PEDAL EDEMA:
          </span>
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            onChange={(e) => handleChange(e)}
            name="pedal"
            style={{
              border: "1px solid #ddd",
              width: "180px",
              marginLeft: "10px",
              padding: "10px",
              outline: "none",
            }}
            // // placeholder="PEDAL EDEMA.."
          ></input>
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{valueChange.pedal}
          </span>
        </div>
        <div style={{ marginTop: "20px" }}>
          <span style={{ fontWeight: "600" }}>PR:</span>
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            onChange={(e) => handleChange(e)}
            name="pr"
            style={{
              border: "1px solid #ddd",
              width: "100px",
              marginLeft: "10px",
              padding: "10px",
              outline: "none",
            }}
            // // placeholder="PR.."
          ></input>
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{valueChange.pr}
          </span>

          <span>/min</span>
          <span style={{ fontWeight: "600", marginLeft: "10px" }}>BP:</span>
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            onChange={(e) => handleChange(e)}
            name="bp"
            style={{
              border: "1px solid #ddd",
              width: "100px",
              marginLeft: "10px",
              padding: "10px",
              outline: "none",
            }}
            // // placeholder="BP.."
          ></input>
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{valueChange.bp}
          </span>

          <span>/mmHg</span>
          <span style={{ fontWeight: "600", marginLeft: "10px" }}>Wt:</span>
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            onChange={(e) => handleChange(e)}
            name="Wt"
            style={{
              border: "1px solid #ddd",
              width: "100px",
              marginLeft: "10px",
              padding: "10px",
              outline: "none",
            }}
            // // placeholder="mmHg.."
          ></input>
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{valueChange.Wt}
          </span>
          <span>/kg</span>
          <>
            <span style={{ fontWeight: "600", marginLeft: "10px" }}>
              Pre Preg Wt:
            </span>
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChange(e)}
              name="ppw"
              style={{
                border: "1px solid #ddd",
                width: "100px",
                marginLeft: "10px",
                padding: "10px",
                outline: "none",
              }}
              // // placeholder="BP.."
            ></input>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.ppw}
            </span>

            <span>/kg</span>
          </>
        </div>
        <div
          style={{
            marginTop: "20px",
            // border: "1px solid red",
            overflowX: "auto",
          }}
        >
          <h3 style={{ marginBottom: "30px", marginTop: "30px" }}>
            INVESTIGATION REPORT:
          </h3>
          <table
            style={{
              marginTop: "10px",
              marginBottom: "30px",
              borderSpacing: 0,
              width: "800px",
            }}
            className="First_table"
          >
            <tbody>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                {renderTableTH("DATE")}
                {renderTableTH("HB")}
                {renderTableTH("PCV")}
                {renderTableTH("TSH")}
                {renderTableTH("OGCT/OGTT")}
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="date"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.date}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="hb"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // // placeholder="HB.."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.hb}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="pvc"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // // placeholder="PCV.."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.pvc}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="tsh"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // // placeholder="TSH..."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.tsh}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="ogct"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // // placeholder="OGCT/OGTT..."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.ogct}
                  </span>
                </td>
                {/* <td style={{ border: "1px solid", padding: "10px" }}><input style={{ padding: "10px", outline: "none", border: "0px" }} // placeholder='Till Delivery...'></input></td> */}
              </tr>
            </tbody>
          </table>
          <table
            style={{ borderSpacing: 0, width: "800px", marginBottom: "30px" }}
          >
            <thead style={{ border: "1px solid", padding: "0px" }}>
              <tr
                style={{
                  border: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <th style={{ border: "1px solid", padding: "10px" }}>S.NO</th>
                <th style={{ border: "1px solid", padding: "10px" }}>DRUG</th>
                <th style={{ border: "1px solid", padding: "10px" }}>DOSAGE</th>
                <th style={{ border: "1px solid", padding: "10px" }}>
                  FREQUENCY
                </th>
                <th style={{ border: "1px solid", padding: "10px" }}>
                  TIME TO TAKE
                </th>
                <th style={{ border: "1px solid", padding: "10px" }}>DAYS</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>1</td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  {/* T.TRITOFER XT/ T.LIVOGEN XT/ SHERRIC FERR */}
                  <select
                    name="drop1"
                    onChange={(e) => handleChange(e)}
                    className={`createTime ${show ? "hide" : "show"}`}
                  >
                    <option selected disabled>
                      Select
                    </option>
                    <option value="T.TRITOFER XT">T.TRITOFER XT</option>
                    <option value="T.LIVOGEN XT">T.LIVOGEN XT</option>
                    <option value="SHERRIC FERR">SHERRIC FERR</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.drop1}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="dos1"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="Dosage.."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.dos1}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  {/* <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="f1"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="0-1-0..."
                  ></input> */}
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="row1"
                    style={{
                      border: "1px solid #ddd",
                      width: "180px",
                      marginLeft: "10px",
                      padding: "10px",
                      outline: "none",
                      backgroundColor: "#fff",
                    }}
                    // // placeholder="POG.."
                  >
                    <option selected disabled>
                      Select
                    </option>
                    <option value={"1-0-0"}>1-0-0</option>
                    <option value={"1-1-1"}>1-1-1</option>
                    <option value={"0-1-0"}>0-1-0</option>
                    <option value={"0-0-1"}>0-0-1</option>
                    <option value={"1-0-1"}>1-0-1</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.row1}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="t1"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="After/Before Food..."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.t1}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="d1"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="Till Delivery..."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.d1}
                  </span>
                </td>
              </tr>
              <tr style={{ borderBottom: "1px solid" }}>
                <td style={{ border: "1px solid", padding: "10px" }}>2</td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <select
                    name="drop2"
                    onChange={(e) => handleChange(e)}
                    className={`createTime ${show ? "hide" : "show"}`}
                  >
                    <option selected disabled>
                      Select
                    </option>

                    <option value="T.INTAFOL D">T.INTAFOL D</option>
                    <option value="FINEFOL">FINEFOL</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.drop2}
                  </span>
                  {/* T.INTAFOL D/ FINEFOL */}
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="dos2"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="Dosage.."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.dos2}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  {/* <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="f2"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="0-1-0"
                  ></input> */}
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="row2"
                    style={{
                      border: "1px solid #ddd",
                      width: "180px",
                      marginLeft: "10px",
                      padding: "10px",
                      outline: "none",
                      backgroundColor: "#fff",
                    }}
                    // // placeholder="POG.."
                  >
                    <option selected disabled>
                      Select
                    </option>

                    <option value={"1-0-0"}>1-0-0</option>
                    <option value={"1-1-1"}>1-1-1</option>
                    <option value={"0-1-0"}>0-1-0</option>
                    <option value={"0-0-1"}>0-0-1</option>
                    <option value={"1-0-1"}>1-0-1</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.row2}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="t2"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="After/Before Food"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.t2}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="d2"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="Till Delivery"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.d2}
                  </span>
                </td>
              </tr>

              <tr style={{ borderBottom: "1px solid black" }}>
                <td style={{ border: "1px solid", padding: "10px" }}>3</td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <select
                    name="drop3"
                    onChange={(e) => handleChange(e)}
                    className={`createTime ${show ? "hide" : "show"}`}
                  >
                    <option selected disabled>
                      Select
                    </option>
                    <option value="T.CALOZEM PLUS">T.CALOZEM PLUS</option>
                    <option value="T.VEHYCAL">T.VEHYCAL</option>
                    <option value="CALOVIT D3">CALOVIT D3</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.drop3}
                  </span>
                  {/* T.CALOZEM PLUS / T.VEHYCAL/ CALOVIT D3 */}
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="dos3"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="Dosage.."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.dos3}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  {/* <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="f3"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="0-1-0..."
                  ></input> */}
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="row3"
                    style={{
                      border: "1px solid #ddd",
                      width: "180px",
                      marginLeft: "10px",
                      padding: "10px",
                      outline: "none",
                      backgroundColor: "#fff",
                    }}
                    // // placeholder="POG.."
                  >
                    <option selected disabled>
                      Select
                    </option>

                    <option value={"1-0-0"}>1-0-0</option>
                    <option value={"1-1-1"}>1-1-1</option>
                    <option value={"0-1-0"}>0-1-0</option>
                    <option value={"0-0-1"}>0-0-1</option>
                    <option value={"1-0-1"}>1-0-1</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.row3}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="t3"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="After/Before Food..."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.t3}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="d3"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="Till Delivery..."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.d3}
                  </span>
                </td>
              </tr>

              <tr style={{ borderBottom: "1px solid" }}>
                <td style={{ border: "1px solid", padding: "10px" }}>4</td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <select
                    name="drop4"
                    onChange={(e) => handleChange(e)}
                    className={`createTime ${show ? "hide" : "show"}`}
                  >
                    <option selected disabled>
                      Select
                    </option>

                    <option value="INJ.Td VAC">INJ.Td VAC</option>
                  </select>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="dos4"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="Dosage.."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.dos4}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <p style={{ display: "inline-block" }}>1st Dose : </p>
                  {/* <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="f41"
                    style={{
                      padding: "10px",
                      outline: "none",
                      border: "0px",
                      width: "63%",
                      marginBottom: "5px",
                    }}
                    // placeholder="1st Dose..."
                  > */}
                  {/* </input> */}
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="f41"
                    style={{
                      border: "1px solid #ddd",
                      width: "180px",
                      marginLeft: "10px",
                      padding: "10px",
                      outline: "none",
                      backgroundColor: "#fff",
                    }}
                    // // placeholder="POG.."
                  >
                    <option selected disabled>
                      Select
                    </option>

                    <option value={"1-0-0"}>1-0-0</option>
                    <option value={"1-1-1"}>1-1-1</option>
                    <option value={"0-1-0"}>0-1-0</option>
                    <option value={"0-0-1"}>0-0-1</option>
                    <option value={"1-0-1"}>1-0-1</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.f41}
                  </span>
                  <br />

                  <p style={{ display: "inline-block" }}>2nd Dose : </p>
                  {/* <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="f42"
                    style={{
                      padding: "10px",
                      outline: "none",
                      border: "0px",
                      width: "60%",
                    }}
                    // placeholder="2nd Dose..."
                  ></input> */}
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="f42"
                    style={{
                      border: "1px solid #ddd",
                      width: "180px",
                      marginLeft: "10px",
                      padding: "10px",
                      outline: "none",
                      backgroundColor: "#fff",
                    }}
                    // // placeholder="POG.."
                  >
                    <option selected disabled>
                      Select
                    </option>

                    <option value={"1-0-0"}>1-0-0</option>
                    <option value={"1-1-1"}>1-1-1</option>
                    <option value={"0-1-0"}>0-1-0</option>
                    <option value={"0-0-1"}>0-0-1</option>
                    <option value={"1-0-1"}>1-0-1</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.f42}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="t4"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="After/Before Food..."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.t4}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="d4"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    // placeholder="Till Delivery..."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.d4}
                  </span>
                </td>
              </tr>
              {/* <tr style={{ borderBottom: "1px solid" }}>
              <td style={{ border: "1px solid", padding: "10px" }}></td>
              <td style={{ border: "1px solid", padding: "10px" }}></td>
              <td style={{ border: "1px solid", padding: "10px" }}><input style={{ border: "0px", padding: "10px", outline: "none" }} // placeholder=''></input></td>
              <td style={{ border: "1px solid", padding: "10px" }}><input style={{ border: "0px", padding: "10px", outline: "none" }} // placeholder='2nd Dosage..'></input></td>
              <td style={{ border: "1px solid", padding: "10px" }}><input style={{ border: "0px", padding: "10px", outline: "none" }} // placeholder=''></input></td>
              <td style={{ border: "1px solid", padding: "10px" }}><input style={{ border: "0px", padding: "10px", outline: "none" }} // placeholder='....'></input></td>
            </tr> */}
              <tr style={{ borderBottom: "1px solid" }}>
                <td style={{ border: "1px solid", padding: "10px" }}>5</td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  {/* MAXVIDA/ VIVA MOM/ VIDAVANCE/ACTAMIN DF/ ACTAMIN D */}
                  <select
                    name="drop5"
                    onChange={(e) => handleChange(e)}
                    className={`createTime ${show ? "hide" : "show"}`}
                  >
                    <option selected disabled>
                      Select
                    </option>

                    <option value="MAXVIDA">MAXVIDA</option>
                    <option value="VIVA MOM">VIVA MOM</option>
                    <option value="VIDAVANCE">VIDAVANCE</option>
                    <option value="ACTAMIN DF">ACTAMIN DF</option>
                    <option value="ACTAMIN D">ACTAMIN D</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.drop5}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="dos5"
                    style={{ border: "0px", padding: "10px", outline: "none" }}
                    // placeholder="WITHONETUMBLEROF MILK /WATER"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.dos5}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="row5"
                    style={{ border: "0px", padding: "10px", outline: "none" }}
                    // placeholder="2tsp -0-2tsp7AM-0-4PM"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.fow5}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="t5"
                    style={{ border: "0px", padding: "10px", outline: "none" }}
                    // placeholder="MORNING&EVENING..."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.t5}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="d5"
                    style={{ border: "0px", padding: "10px", outline: "none" }}
                    // placeholder="Till Delivery..."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.d5}
                  </span>
                </td>
              </tr>
              <tr style={{ borderBottom: "1px solid" }}>
                <td style={{ border: "1px solid", padding: "10px" }}>6</td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  {/* <select name="drop4" onChange={(e) => handleChange(e)}> */}
                  {/* <option value="" disabled selected>
                        Select a Title
                      </option> */}
                  {/* <option value="VAGIWASH LOTION( FOR VAGINAL USE )">
                      VAGIWASH LOTION( FOR VAGINAL USE )
                    </option> */}
                  {/* <option value="SILKY WASH">SILKY WASH</option> */}
                  {/* </select> */}
                  {/* <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.drop4}
                  </span> */}
                  <select
                    name="drop6"
                    onChange={(e) => handleChange(e)}
                    className={`createTime ${show ? "hide" : "show"}`}
                  >
                    <option selected disabled>
                      Select
                    </option>

                    <option value="VAGIWASH LOTION( FOR VAGINAL USE)/ SILKY WASH">
                      VAGIWASH LOTION( FOR VAGINAL USE)/ SILKY WASH
                    </option>
                  </select>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="dos6"
                    style={{ border: "0px", padding: "10px", outline: "none" }}
                    // placeholder="Dosage.."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.dos6}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  {/* <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="f6"
                    style={{ border: "0px", padding: "10px", outline: "none" }}
                    // placeholder="0-1-0..."
                  ></input> */}
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="row6"
                    style={{
                      border: "1px solid #ddd",
                      width: "180px",
                      marginLeft: "10px",
                      padding: "10px",
                      outline: "none",
                      backgroundColor: "#fff",
                    }}
                    // // placeholder="POG.."
                  >
                    <option selected disabled>
                      Select
                    </option>
                    <option value={"1-0-0"}>1-0-0</option>
                    <option value={"1-1-1"}>1-1-1</option>
                    <option value={"0-1-0"}>0-1-0</option>
                    <option value={"0-0-1"}>0-0-1</option>
                    <option value={"1-0-1"}>1-0-1</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.row6}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="t6"
                    style={{ border: "0px", padding: "10px", outline: "none" }}
                    // placeholder="TO WASHWITHWATER..."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.t6}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="d6"
                    style={{ border: "0px", padding: "10px", outline: "none" }}
                    // placeholder="...."
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.d6}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ marginTop: "20px" }}>
          <ul style={{ lineHeight: "2rem", fontSize: "18px" }}>
            <li>
              Kindly follow the Do's and Don'ts of second trimester as advised,
              can look for more information in &nbsp;
              <b>
                <span>Doctor Mommies Youtube Channel</span>
                {/* <span>&nbsp;{valueChange.youtube}</span> */}
                <a
                  className={`input ${!show ? "hide" : "show"}`}
                  href={valueChange.youtube}
                  target="_blank"
                >
                  {valueChange.youtube}
                </a>
              </b>
            </li>
            <li className="text-wrap">
              To your information, after pregnancy is confirmed the registration
              has to be done in PICME.tn.gov.in/ nearby PHC . For more details
              contact front office
            </li>
            <li>
              Any emergency / bleeding / pain do contact us in{" "}
              <b>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  name="emgNum"
                  style={{
                    marginLeft: "10px",
                    border: "1px solid #ddd",
                    padding: "10px",
                    outline: "none",
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.slice(0, 10);
                  }}
                  // placeholder="Emergency Number..."
                ></input>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.emgNum}
                </span>
              </b>
              .
            </li>
            <li className="text-wrap">
              Review for reports : Dual marker advised should be done and report
              to be shown in person by attender in 1 week time or send to our
              Whatsapp Number :
              <b>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  name="whaNum"
                  onInput={(e) => {
                    e.target.value = e.target.value.slice(0, 10);
                  }}
                  type="number"
                  maxLength={"10"}
                  style={{
                    marginLeft: "10px",
                    border: "1px solid #ddd",
                    padding: "10px",
                    outline: "none",
                  }}
                  // placeholder="WhatsApp Number..."
                ></input>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.whaNum}
                </span>
              </b>
            </li>
            <li>
              Review : 1 month later with prior appointments at 7AM - 9PM.
            </li>
          </ul>
        </div>
      </div>
      <p style={{fontWeight:"600"}}>
NEXT APPOINTMENT -{" "}
<input
name="nextappointment"
onChange={handleChange}
type="datetime-local"
// type="date"
/>
</p>
      <div className="Footer">
        <button onClick={handletest} className="Button_Create">
          Add Prescription
        </button>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h5 style={{ fontWeight: 600, marginRight: "5px" }}>
              Visit Remarks
            </h5>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <span style={{ marginLeft: "10px" }}>{valueChange.visit}</span>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("LMP :", valueChange.lmp)}
            {renderReportfield("EDD :", valueChange.edd)}
            {renderReportfield("POG :", valueChange.pog)}
            {renderReportfield("NT SCAN :", valueChange.ntScan)}
            {renderReportfield("D/B :", valueChange.ntScan)}
            {renderReportfield("DUAL MARKER :", valueChange.dualMarker)}
          </div>

          <div style={{ display: "flex", marginTop: "10px" }}>
            <h5 style={{ fontWeight: 600, marginRight: "5px" }}>COMPLAINTS</h5>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <span style={{ marginLeft: "10px" }}>{valueChange.complaints}</span>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("O/E :", valueChange.oe)}
            {renderReportfield("PEDAL EDEMA :", valueChange.pedal)}
            {renderReportfield("PR :", valueChange.pr)}/min
            {renderReportfield("BP :", valueChange.bp)}/mmHg
            {renderReportfield("Wt :", valueChange.Wt)}/Kg
            {renderReportfield("Pre Preg Wt :", valueChange.ppw)}/kg
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h5 style={{ fontWeight: 600, marginRight: "5px" }}>
              INVESTIGATION REPORT:
            </h5>
          </div>
          <div>
            <table
              style={{
                borderSpacing: "0",
                marginBottom: "30px",
                width: "98%",
              }}
            >
              <thead>
                <tr>
                  {renderTableTH("DATE")}
                  {renderTableTH("HB")}
                  {renderTableTH("PCV")}
                  {renderTableTH("TSH")}
                  {renderTableTH("OGCT/OGTT")}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {[
                    valueChange.date,
                    valueChange.hb,
                    valueChange.pcv,
                    valueChange.tsh,
                    valueChange.ogct,
                  ].map((ele) => renderTableTD(ele))}
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <table
              style={{
                borderSpacing: "0",
                marginBottom: "30px",
                width: "98%",
              }}
            >
              <thead>
                <tr>
                  {[
                    "S.No",
                    "DRUG",
                    "DOSAGE",
                    "FREQUENCY",
                    "TIME TO TAKE",
                    "DAYS",
                  ].map((ele) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {[...Array(6)].map((ele, ind) => {
                  return (
                    <tr key={ind}>
                      {renderTableTD(ind + 1)}
                      {["drop", "dos", "row", "t", "d"].map((inEle) => {
                        return (
                          <>
                            {ind === 3 && inEle === "row" ? (
                              <>
                                <td
                                  style={{
                                    border: "1px solid black",
                                    textAlign: "center",
                                  }}
                                >
                                  <p>1st Dose : {valueChange.f41}</p>
                                  <p>2nd Dose : {valueChange.f42}</p>
                                </td>
                              </>
                            ) : (
                              renderTableTD(valueChange[`${inEle + (ind + 1)}`])
                            )}
                          </>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div>
            <p>
              • Kindly follow the Do's and Don'ts of second trimester as
              advised, can look for more information in <br />
              <p style={{ fontWeight: "bolder", marginLeft: "10px" }}>
                Doctor Mommies Youtube Channel
              </p>{" "}
            </p>
            <p>
              • To your information, after pregnancy is confirmed the
              registration has to be done in PICME.tn.gov.in/ nearby PHC . For
              more details contact front office{" "}
            </p>
            <p>
              • Any emergency / bleeding / pain do contact us in <br />
              <p style={{ fontWeight: "bolder", marginLeft: "10px" }}>
                {valueChange.emgNum}
              </p>{" "}
            </p>
            <p>
              • Review for reports : Dual marker advised should be done and
              report to be shown in person by attender in 1 week time or send to
              our Whatsapp Number : <br />
              <p style={{ fontWeight: "bolder", marginLeft: "10px" }}>
                {valueChange.whaNum}
              </p>{" "}
            </p>
            <p>
              • Review : 1 month later with prior appointments at 7AM - 9PM.
            </p>
          </div>
          <div style={{ marginTop: "10px" }}>
{renderReportfield("Next Appointment : ",appointmentData.date?.split("-").reverse().join("-"))}
</div>
          <p class="Dani"></p>
        </div>
      </div>
    </>
  );
}

export default PrescriptionTemplate_temp;
